import React from 'react'
import {
  Card,
  CardContent,
  makeStyles,
  Typography,
  Grid,
  List,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import PropTypes from 'prop-types'
import { useTranslate } from 'react-admin'
import CheckIcon from '@material-ui/icons/Check'
import subscriptionAddonCardStyles from './subscriptionAddonCardStyles'
import COLORS from '../../../utils/constants/colors'
import TextButton from '../../../components/ui/TextButton/TextButton'
import addonInfo from '../../../utils/constants/addonInfo'
import subscriptionIconMapper from '../../../utils/constants/subscriptionMapper'

const SubscriptionAddonCard = ({
  addon,
  nonActivatableAddons,
  isAddonConfirmation,
  orgId,
  children,
}) => {
  const { id, displayName, pricingModel, enabled } = addon || {}
  const translate = useTranslate()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(1281))
  const useStyles = makeStyles(subscriptionAddonCardStyles(enabled))
  const classes = useStyles()

  const mapPricingModel = (pricingModel) => {
    const subtitles = {
      Fixed: 'monthly',
      PerHour: 'per hour',
      Manual: null,
    }

    if (pricingModel === 'Manual') {
      return <span style={{ color: '#999', fontSize: isSmallScreen ? '11px' : '13px' }}>Offline Payment</span>
    }

    return <span style={{ color: '#999', fontSize: isSmallScreen ? '11px' : '13px' }}>{subtitles[pricingModel] || pricingModel}</span>
  }

  const buttonProps = {
    className: classes.button,
    style: {
      height: '30px',
      backgroundColor: COLORS.opacBlue,
      border: `1px solid ${COLORS.subscriptionBlue}`,
      color: COLORS.subscriptionBlue,
      fontSize: isSmallScreen ? '12px' : '14px',
    },
  }

  const isButtonDisabled =
    nonActivatableAddons ||
    (id === 'Livestream' && enabled) ||
    (id === 'Studio' && enabled) ||
    (id === 'Engage' && enabled)

  const getCardButton = () => {
    if (isButtonDisabled) return null

    return (
      <TextButton
        {...buttonProps}
        label={translate('ra.buttons.contactUs')}
        onClick={() => window.open('https://www.mismatch.gr/contact/', '_blank')}
      />
    )
  }

  return (
    <Card variant='outlined' elevation={0} className={classes.planCard}>
      <CardContent className={classes.cardContent}>
        <Grid
          item
          sm={nonActivatableAddons ? 4 : 2}
          style={{
            display: 'flex',
            justifyContent: isSmallScreen ? 'center' : 'flex-start',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: isSmallScreen ? 'column' : 'row',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: isSmallScreen ? 'center' : '',
              }}
            >
              {subscriptionIconMapper[id]}
            </div>
            <Typography
              variant='h6'
              style={{
                fontWeight: 'bold',
                marginLeft: 5,
                fontSize: isSmallScreen ? '14px' : '20px',
              }}
            >
              {displayName || id}
            </Typography>
          </div>
        </Grid>
        {isButtonDisabled ? (
          <Grid
            item
            sm={4}
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {(addonInfo[id] ?? []).map((feature) => (
              <List key={feature} className={classes.dotText}>
                <ListItemIcon style={{ minWidth: 20 }}>
                  <CheckIcon className={classes.check} />
                </ListItemIcon>
                <ListItemText
                  primary={feature}
                  primaryTypographyProps={{ style: { fontSize: isSmallScreen ? '12px' : '16px' } }}
                />
              </List>
            ))}
          </Grid>
        ) : (
          <Grid
            item
            sm={nonActivatableAddons ? 6 : 4}
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {(addonInfo[id] ?? []).map((feature) => (
              <List key={feature} className={classes.dotText}>
                <ListItemIcon style={{ minWidth: 20 }}>
                  <CheckIcon className={classes.check} />
                </ListItemIcon>
                <ListItemText
                  primary={feature}
                  primaryTypographyProps={{ style: { fontSize: isSmallScreen ? '12px' : '16px' } }}
                />
              </List>
            ))}
          </Grid>
        )}

        <Grid
          item
          sm={isSmallScreen ? 4 : 3}
          style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
        >
          {!nonActivatableAddons && isSmallScreen && (
            <Typography variant='body1' style={{ fontSize: isSmallScreen ? '12px' : '16px' }}>
              {mapPricingModel(pricingModel)}
            </Typography>
          )}
        </Grid>
        {!isAddonConfirmation ? (
          <>
            {!nonActivatableAddons && !isSmallScreen && (
              <Grid
                item
                sm={2}
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
              >
                <Typography variant='body1' style={{ fontSize: isSmallScreen ? '12px' : '16px' }}>
                  {mapPricingModel(pricingModel)}
                </Typography>
              </Grid>
            )}

            <Grid
              item
              sm={nonActivatableAddons ? 4 : 2}
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <div style={{ display: 'flex', justifyContent: 'center', width: '80%' }}>
                {!nonActivatableAddons ? (
                  getCardButton()
                ) : id === 'Livestream' ? (
                  <List className={classes.priceColumn}>
                    <ListItemText
                      primary={
                        <TextButton
                          label={translate('ra.buttons.contactUs')}
                          className={classes.button}
                          style={{
                            height: '25px',
                            fontSize: isSmallScreen ? '10px' : '12px',
                            backgroundColor: COLORS.opacBlue,
                            border: `1px solid ${COLORS.subscriptionBlue}`,
                            color: COLORS.subscriptionBlue,
                          }}
                          onClick={() => window.open('https://www.mismatch.gr/contact/', '_blank')}
                        />
                      }
                    />
                  </List>
                ) : (
                  <List className={classes.priceColumn}>
                    <ListItemText primary='Contact Us' />
                  </List>
                )}
              </div>
            </Grid>
          </>
        ) : (
          <Grid
            item
            sm={2}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          >
            <Typography variant='body1' style={{ fontSize: isSmallScreen ? '12px' : '16px' }}>
              {mapPricingModel(pricingModel)}
            </Typography>
          </Grid>
        )}
      </CardContent>
      {children}
    </Card>
  )
}

SubscriptionAddonCard.propTypes = {
  addon: PropTypes.shape({
    id: PropTypes.string.isRequired,
    displayName: PropTypes.string,
    name: PropTypes.string.isRequired,
    pricing: PropTypes.string,
    enabled: PropTypes.bool.isRequired,
  }),
  nonActivatableAddons: PropTypes.bool,
  isAddonConfirmation: PropTypes.bool,
  orgId: PropTypes.string,
}

SubscriptionAddonCard.defaultProps = {
  addon: null,
  nonActivatableAddons: null,
  isAddonConfirmation: false,
}

export default SubscriptionAddonCard
